import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useStyles } from './styles';
const steps = [
    {
        title: 'Перейдите по ссылке в полисе',
        description: 'При задержке рейса более 3 часов, перейдите по ссылке в полисе и сообщите о событии.',
    },
    {
        title: 'Проверьте свои данные',
        description: 'Дождитесь SMS и перейдите по ссылке для проверки своих данных в заявлении на выплату.',
    },
    {
        title: 'Укажите данные карты',
        description: 'Укажите данные российской карты для зачисления выплаты',
    },
    {
        title: (_jsxs(_Fragment, { children: ["\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 ", _jsx("span", { className: "desktop-line-break" }), "\u0434\u0435\u043D\u044C\u0433\u0438"] })),
        description: 'Выплата до 15 000 рублей при задержке или до 12 000 рублей при отмене рейса',
    },
];
export const Steps = memo(() => {
    const classes = useStyles();
    return (_jsx(_Fragment, { children: _jsx("section", { className: classes.section, "data-no-padding": true, children: _jsxs("div", { className: classes.stepsContainer, children: [_jsx("h2", { className: classes.title, children: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435" }), _jsx("ul", { className: classes.stepsList, children: steps.map(({ title, description }, index) => (_jsxs("li", { className: classes.stepContainer, children: [_jsx("div", { className: classes.stepIndex, children: index + 1 }), _jsxs("div", { children: [_jsx("h3", { className: classes.stepTitle, children: title }), _jsx("p", { className: classes.stepDescription, children: description })] })] }, index))) })] }) }) }));
});
